module.exports = {"items":[{"itemName":"PC","itemCount":2},{"itemName":"MAC","itemCount":4}],"selectedItems":[]}


//////////////////
// WEBPACK FOOTER
// ./public_html/_/components/js/initialState.json
// module id = 172
// module chunks = 0